import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'postcode',
})
export class PostcodePipe implements PipeTransform {
  constructor() {}

  transform(v: string): string {
    if (v == null || v.length <= 4) {
      return v.toUpperCase();
    }

    if (v.indexOf('*') >= 0) {
      return v.toUpperCase();
    }

    return v
      .replace(/ /g, '')
      .replace(/(?=.{3}$)/, ' ')
      .toUpperCase();
  }
}
